/**
 * NotFoundCatcher — rendered by the root-level `<Route path="*">`.
 * Logs the unmatched URL to the route-health sentinel and shows a
 * friendly 404 with a home button.
 */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import RouteHealthReporter from "../lib/routeHealthReporter";

export default function NotFoundCatcher() {
  useEffect(() => {
    RouteHealthReporter.report({ kind: "not_found" });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-slate-50" data-testid="not-found-page">
      <div className="max-w-md w-full text-center">
        <p className="text-xs uppercase tracking-widest text-slate-400 mb-3">Error 404</p>
        <h1 className="text-3xl font-bold text-slate-900 mb-2">Page not found</h1>
        <p className="text-sm text-slate-500 mb-6">
          The page you were looking for doesn't exist or has moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center px-4 py-2 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-800"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}
